import { FileType } from '@office-start/document-types';
var NameToFileType = {
    none: FileType.None,
    excel: FileType.Excel,
    onenote: FileType.OneNote,
    pdf: FileType.Pdf,
    powerpoint: FileType.PowerPoint,
    audio: FileType.Audio,
    video: FileType.Video,
    visio: FileType.Visio,
    word: FileType.Word,
    photos: FileType.Photos,
    text: FileType.Text,
    outlook: FileType.Outlook,
    sway: FileType.Sway,
    forms: FileType.Forms,
    formsquiz: FileType.FormsQuiz,
    project: FileType.Project,
    projectoperations: FileType.ProjectOperations,
    portfolio: FileType.Portfolio,
    news: FileType.NewsArticle,
    newsarticle: FileType.NewsArticle,
    onedrive: FileType.OneDrive,
    sharepoint: FileType.SharePoint,
    bohemia: FileType.Fluid,
    fluid: FileType.Fluid,
    powerbi: FileType.PowerBI,
    streamsvideo: FileType.StreamsVideo,
    yammer: FileType.Yammer,
    mindmeister: FileType.MindMeister,
    stream: FileType.Stream,
    monday: FileType.Monday,
    trello: FileType.Trello,
    platform: FileType.Platform,
    image: FileType.Image,
    media: FileType.Media,
    whiteboard: FileType.Whiteboard,
    meetingnotes: FileType.MeetingNotes,
    screenrecording: FileType.ScreenRecording,
    designer: FileType.Designer,
    list: FileType.List,
    clipchamp: FileType.Clipchamp,
    loop: FileType.Loop,
    loopworkspace: FileType.LoopWorkspace,
};
// TODO: Rename this to be consistent with other `getFileType...` functions
export function getTypeFromFileTypeName(fileTypeName) {
    if (!fileTypeName) {
        return;
    }
    return NameToFileType[fileTypeName.toLowerCase()];
}
//# sourceMappingURL=getTypeFromFileTypeName.js.map